/**
 * Created by slipkinem on 5/27/2017.
 */
//@ts-nocheck
import setTitle from '../utils/setTitle';
import apiUtil from "@/apiUtil";
import PlatformInteractionUtil from '@/utils/PlatformInteractionUtil';
import tokenUtil from '@/utils/TokenUtil';
const updateViewport = (allowScale) => {
  const viewport = document.getElementById('dynamic-viewport');
  if (allowScale) {
    // 允许全局缩放：移除 maximum-scale/minimum-scale 限制
    viewport.content = 'width=device-width, initial-scale=1.0';
  } else {
    // 禁止全局缩放：限制最大/最小缩放为 1.0，禁止浏览器默认缩放
    viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover';
  }
};
// 路由拦截
export async function routerBeforeEach(to, from, next) {
  const allowScale = to.meta.allowScale ?? false;
  updateViewport(allowScale);
  // 设置标题
  if (to.meta.title) {
    setTitle(to.meta.title)
  }
  if (to.query.clientId) {
    sessionStorage.setItem('clientId', to.query.clientId)
  }
  if (to.query.terminal) {
    sessionStorage.setItem('terminal', to.query.terminal)
  }
  if (to.query.platformCode) {
    sessionStorage.setItem('platformCode', to.query.platformCode)
  }
  if(to.query.isback && PlatformInteractionUtil.isAndroidOrIOS()=== 'android' && PlatformInteractionUtil.isWeiXin()){
    to.meta.navbar = true
  }
  if (to.meta.needLogin618) {
    const data = {
      cardCode: to.query.cardCode,
      sign: to.query.signMD5
    }
    const {data: {token}} = await apiUtil.apiUtilPost('/api/activity/auth/login', data)
    console.log(token);
    tokenUtil.setToken(token)
    next()
  }
  if (to.meta.needLogin) {
    let params = null;
    if (to.query.cardCode == null && localStorage.getItem('homeQuery') != null) {
      params = JSON.parse(localStorage.getItem('homeQuery'))

    } else {
      params = {
        cardCode: to.query.cardCode,
        signMD5: to.query.signMD5
      }
    }
    console.log(to.query)
    localStorage.setItem('homeQuery', JSON.stringify(to.query));
    if (to.query.edition != null) {
      localStorage.setItem('edition', to.query.edition)
    }
    await apiUtil.apiUtilGet('/PKECUser/auth/PKH5Login', params);
  }
  if (to.meta.hasAppNav === 0) {
    PlatformInteractionUtil.setNavBarHidden(1)
  } else if (to.meta.hasAppNav === 1) {
    PlatformInteractionUtil.setNavBarHidden(0)
  }
  next();
}
